import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HeadComponent} from "../../components/head/head.component";
import {Router} from "@angular/router";
import {StockService} from "../../services/api/stocks/stock.service";
import {UserService} from "../../services/api/user/user.service";
import {User} from "../../services/api/user/models";


@Component({
  selector: 'app-home-page',
  standalone: true,
  imports: [
    HeadComponent
  ],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.css'
})

export class HomePageComponent implements OnInit, OnChanges {
  user: User | undefined;
  outStockMetric: number = 0;
  lowStockMetric: number = 0;
  inStockMetric: number = 0;

  constructor(public router: Router,
              public stockService: StockService,
              public userService: UserService,
              ) {
  }


  ngOnInit(): void {
    this.getMyProfile()
    this.getMetrics();
  }

  ngOnChanges() {
    this.getMetrics();
  }

  getMetrics() {
    this.stockService.getStockMetric().subscribe(res => {
      this.outStockMetric = res.out_stock
      this.lowStockMetric = res.low_stock
      this.inStockMetric = res.in_stock
    })
  }

  getMyProfile() {
    this.userService.getMe().subscribe(res => {
      this.user = res;
    })
  }

  routeTo(link: string) {
    this.router.navigate([link]);
  }

}
